export const validSlug = (value: string): boolean => {
  return /^[a-zA-Z0-9_-]*$/.test(value);
};

export const certificateWithComments = (value: string): boolean => {
  return value.includes('-----');
};
